export default "__VITE_ASSET__DiMN9ArZ__"